import { QueryObserverResult, useQuery } from '@tanstack/react-query';

import {
  API_QUERY_KEYS,
  getFilterAuthorities,
  GetFilterAuthoritiesResponse,
  QueryDefaults,
} from 'api';

export const useFilterAuthorities = (): QueryObserverResult<GetFilterAuthoritiesResponse> =>
  useQuery([API_QUERY_KEYS.getFilterAuthorities], getFilterAuthorities, QueryDefaults);
